import { Link } from "react-router-dom";
import { typeCategories } from "@/mocks/site";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
      <SectionHeading
        eyebrow="Browse"
        title="分类快捷入口"
        subtitle="六大热门影视类别，一键直达你感兴趣的内容"
      />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {typeCategories.map((c) => (
          <Link
            key={c.key}
            href={`/category?type=${encodeURIComponent(c.key)}`}
            to={`/category?type=${encodeURIComponent(c.key)}`}
            className="group bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 hover:border-primary-300 hover:-translate-y-0.5 transition-all cursor-pointer"
          >
            <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${c.icon} text-xl`}></i>
            </span>
            <h3 className="font-heading text-base font-semibold text-foreground-950">{c.key}</h3>
            <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{c.desc}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}